import {BaseService, ServiceLoopbackFilters} from '../../services/base-service/base.service';
import {IDisease} from './disease.interface';
import {IDiseaseCategory} from './disease-category.interface';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {firstValueFrom} from 'rxjs';

export interface IRDiseases {
  diseaseCategories: IDiseaseCategory[];
  diseases: IDisease[];
}

export namespace DiseaseActions {
  export class GetCategories {
    static readonly type: string = '[Record] Get Disease Categories Action';
    constructor(public filters: ServiceLoopbackFilters) { }
  }
}


@State<IRDiseases>({
  name: 'DiseasesState',
  defaults: {
    diseaseCategories: [],
    diseases: []
  },
})

@Injectable()
export class DiseasesState {
  constructor(
    private baseService: BaseService<any>
  ) {
  }

  url = environment.SERVER_URL;

  @Selector()
  public static getDiseaseCategories(state: IRDiseases): IDiseaseCategory[] {
    return state.diseaseCategories;
  }

  @Selector()
  public static getDiseases(state: IRDiseases): IDisease[] {
    return state.diseases;
  }

  @Action(DiseaseActions.GetCategories)
  async getDiseaseCategoriesAction(ctx: StateContext<IRDiseases>, action: DiseaseActions.GetCategories): Promise<void> {
    if (ctx.getState()?.diseaseCategories?.length > 0) return;
    const response = await firstValueFrom((this.baseService.get(`${this.url}/diseases/categories`, action.filters)));
    if (response.error) {
      throw new Error(response.message);
    }
    ctx.patchState({
      diseaseCategories: response.entity
    });
  }
}
